import { __require as o } from "./main29.js";
var r, i;
function a() {
  if (i) return r;
  i = 1;
  var t = o();
  function n(e) {
    return e == null ? "" : t(e);
  }
  return r = n, r;
}
export {
  a as __require
};
